import React, { useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { ContentContext } from "@/pages/Layout";
import PageCover from "@/components/PageCover";
import Media from "@/components/Media";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

export default function Fairs() {
  const { t, loc } = useApp();
  const content = useContext(ContentContext);
  const [items, setItems] = useState([]);
  const [sel, setSel] = useState(null);

  useEffect(() => { api.get("/fairs").then((r) => setItems(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="fairs-page">
      <PageCover testId="fairs-cover" image={content?.covers?.fairs} overline="Exhibitions" title={t("fairs")} />

      <div className="px-6 md:px-12 py-16 md:py-24">
        <div className="max-w-[1600px] mx-auto">
          {items.length === 0 ? (
            <p data-testid="fairs-empty" className="text-sm text-neutral-500">{t("noItems")}</p>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {items.map((f, i) => (
                <button key={f.id} data-testid={`fair-card-${i}`} onClick={() => setSel(f)}
                  className="group text-left border border-white/5 bg-[#0c0c0c] hover:border-gold/30 transition-colors duration-300">
                  <div className="aspect-[16/10] overflow-hidden">
                    <Media item={f.media?.[0]} className="transition-transform duration-700 group-hover:scale-105" />
                  </div>
                  <div className="p-7">
                    <p className="text-[0.62rem] uppercase tracking-[0.2em] text-gold">{f.location} {f.date && `· ${f.date}`}</p>
                    <h3 className="font-serif text-3xl text-white mt-2">{f.fair_name}</h3>
                    <p className="text-sm text-neutral-500 mt-3 line-clamp-2">{loc(f.description)}</p>
                  </div>
                </button>
              ))}
            </div>
          )}
        </div>
      </div>

      <Dialog open={!!sel} onOpenChange={() => setSel(null)}>
        <DialogContent data-testid="fair-dialog" aria-describedby={undefined} className="bg-[#0a0a0a] border border-white/10 max-w-4xl p-0">
          {sel && (
            <div className="max-h-[85vh] overflow-y-auto scrollbar-thin">
              <div className="p-8 pb-4">
                <p className="overline">{sel.location} {sel.date && `· ${sel.date}`}</p>
                <DialogTitle className="font-serif text-4xl font-light text-white mt-3">{sel.fair_name}</DialogTitle>
                <p className="text-sm text-neutral-400 mt-5 leading-relaxed whitespace-pre-line">{loc(sel.description)}</p>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-1 p-1">
                {(sel.media || []).map((m, i) => (
                  <div key={i} className="aspect-video"><Media item={m} testId={`fair-media-${i}`} /></div>
                ))}
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
